import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=642c0ade&"
import script from "./CollectionFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports